import React from "react";
import { Close } from "@mui/icons-material";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from "@mui/material";
import moment from "moment";
import Label from "../../Label";
import { capitalise } from "../../../utils/tableFunctions";
import Quill from "../wysiwyg-html-editor";

function ViewDialog({ data, handleClose }) {
  return (
    <Dialog fullWidth maxWidth="sm" open={true} onClose={handleClose}>
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          View Product Update
          <Button
            variant="outlined"
            onClick={handleClose}
            startIcon={<Close />}
          >
            Cancel
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Service scope"
          fullWidth
          variant="standard"
          value={data?.service_scope}
          disabled={true}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000",
            },
            mb: 5,
          }}
        />

        <TextField
          label="Title"
          fullWidth
          variant="standard"
          value={data?.title}
          disabled={true}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000",
            },
            mb: 5,
          }}
        />

        <Quill
          title="Description"
          value={data?.description}
          sx={{ mb: 2 }}
          readOnly
          toolbar={false}
          styles={{
            height: "auto",
          }}
        />
        <TextField
          label="Published Date"
          fullWidth
          variant="standard"
          value={
            data?.published_date
              ? moment(data.published_date).format("DD-MM-YYYY")
              : "-"
          }
          disabled={true}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000",
            },
            mb: 5,
          }}
        />

        <Typography>Status</Typography>
        {data?.status && (
          <Label
            variant="ghost"
            color={
              data.status === "published"
                ? "success"
                : data.status === "canceled"
                ? "error"
                : "primary"
            }
          >
            {capitalise(data.status)}
          </Label>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ViewDialog;
